module.exports = __webpack_public_path__ + "img/column_guohua.aa6948d2.png";